import { render, staticRenderFns } from "./ProjectWorkItemList.vue?vue&type=template&id=058a5805&scoped=true"
import script from "./ProjectWorkItemList.vue?vue&type=script&lang=js"
export * from "./ProjectWorkItemList.vue?vue&type=script&lang=js"
import style0 from "./ProjectWorkItemList.vue?vue&type=style&index=0&id=058a5805&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058a5805",
  null
  
)

export default component.exports